import { render } from "./LLinksForm.vue?vue&type=template&id=6bd87a4e&scoped=true&ts=true"
import script from "./LLinksForm.vue?vue&type=script&lang=ts"
export * from "./LLinksForm.vue?vue&type=script&lang=ts"

import "./LLinksForm.vue?vue&type=style&index=0&id=6bd87a4e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd87a4e"]])

export default __exports__